import { createGlobalStyle } from 'styled-components';

export const HideHubspotBubbleStyle = createGlobalStyle`
    body #hubspot-messages-iframe-container {        
        display: none !important;
    }
`;
